import { useCallback, useEffect, useState } from "react"

import {
  closeOpenModal,
  ModalType,
  selectOpenModal,
  setActionStatus,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import ErrorOnMatsClaimModal from "#/shared/components/modals/ErrorOnMatsClaimModal"
import { useMobileScreen } from "#/shared/hooks"
import {
  FirstBorrowModal,
  ManageCollateralModal,
  RepayBorrowModal,
  UpdateBorrowModal,
} from "#/ui/Borrow"
import AddLiquidityModal from "#/ui/LiquidityPage/modals/AddLiquidity"
import MarketTransactionDetailsModal from "#/ui/Market/TransactionDetailsModal/MarketTransactionDetailsModal"
import { MigrateToMainnetModal } from "#/ui/MigrateToMainnet"
import { BridgeAssetModal, OnboardingModal } from "#/ui/Modal"
import {
  ManageStakeModal,
  StakeWithdrawalModal,
  StakingModal,
} from "#/ui/StakingPage/modals"

import ConnectWalletModal from "../ConnectWallet/ConnectWalletModal"
import ErrorModal from "../ErrorModal"
import StackMatsnetBtcModal from "../StackMatsnetBtcModal"
import StbtcManageModal from "../Stbtc/StbtcManageModal"
import WithdrawalModal from "../WithdrawalModal"

const useModalManagement = () => {
  const modalType = useDappSelector(selectOpenModal)
  const dispatch = useDappDispatch()
  const isMobile = useMobileScreen()

  const [forceOpenModal, setForceOpenModal] = useState<ModalType>(null)

  const closeModal = useCallback(() => {
    dispatch(closeOpenModal())
    dispatch(setActionStatus("idle"))
    setForceOpenModal(null)
  }, [dispatch])

  useEffect(() => {
    if (isMobile) {
      setForceOpenModal(modalType)
    } else {
      setForceOpenModal(null)
    }
  }, [modalType, isMobile])

  const getModalProps = useCallback(
    (type: ModalType) => ({
      isOpen: modalType === type || forceOpenModal === type,
      onClose: closeModal,
    }),
    [modalType, forceOpenModal, closeModal],
  )

  return { getModalProps }
}

export default function MezoModal() {
  const { getModalProps } = useModalManagement()

  return (
    <>
      <ConnectWalletModal {...getModalProps("wallet-connect")} />
      <WithdrawalModal {...getModalProps("withdrawal")} />
      <StbtcManageModal {...getModalProps("stbtc-manage")} />
      <StackMatsnetBtcModal {...getModalProps("stack-matsnet-btc")} />
      <MarketTransactionDetailsModal
        {...getModalProps("transaction-details")}
      />
      <ErrorModal {...getModalProps("error-modal-generic")} />
      <ErrorModal
        {...getModalProps("error-modal-support")}
        shouldContactSupport
      />
      <ErrorOnMatsClaimModal {...getModalProps("error-mats-claim")} />
      <FirstBorrowModal {...getModalProps("borrow-first")} />
      <ManageCollateralModal {...getModalProps("borrow-manage")} />
      <UpdateBorrowModal {...getModalProps("borrow-update")} />
      <RepayBorrowModal {...getModalProps("borrow-repay")} />
      <OnboardingModal {...getModalProps("onboarding")} />
      <AddLiquidityModal {...getModalProps("add-liquidity")} />
      <StakingModal {...getModalProps("staking")} />
      <StakeWithdrawalModal {...getModalProps("stake-withdrawal")} />
      <ManageStakeModal {...getModalProps("manage-stake")} />
      <MigrateToMainnetModal {...getModalProps("migrate-to-mainnet")} />
      <BridgeAssetModal {...getModalProps("bridge-asset")} />
    </>
  )
}
